import { decorate, observable, flow } from 'mobx';

import { queuedWorkOrderUrl } from './APIEndpoints';
import Api from './APIEndpoints';
import {appStore} from './AppStore';

const PENDING = 'pending';
const DONE = 'done';
const ERROR = 'error';

export default class ArticleListStore {

  articles = [];
  listState = PENDING;
  rowCount = 0;

  constructor(props) {
    this.apiProxy = props.apiProxy;   
  }
  
  fetchArticlesInQueue = flow(function* () {
    this.listState = PENDING;

    try {
      const params = { "where": { "userId":appStore.credentials.userId.toString()}, "limit": "5" }
      const data = yield Api.queuedWorkOrderUrl.get(params);
      // const response = yield this.apiProxy.getAsync(queuedWorkOrderUrl);
      // const data = yield response.json();

      this.articles = data;
      this.rowCount = data.length;
      this.listState = DONE;
    }
    catch (e) {
      this.listState = ERROR;
    };
  });

  
}

decorate(ArticleListStore, {
  listState: observable,
  articles: observable,
  rowCount: observable
})
